import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import { Icon } from 'tdesign-vue-next'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'

const app = createApp(App)

// 注册所有Element Plus图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.use(ElementPlus, { locale: zhCn })
app.use(Icon)
app.use(createPinia())
app.use(router)

// 动态加载极验脚本（避免重复注入）
const addGeetestScript = () => {
  const existing = document.querySelector('script[src*="static.geetest.com/v4/gt4.js"]')
  if (existing) return
  const script = document.createElement('script')
  script.src = 'https://static.geetest.com/v4/gt4.js'
  script.async = true
  document.head.appendChild(script)
}

addGeetestScript();

app.mount('#app')
